export const getErrorMessage = (error: any): string => {
  const data = error?.response?.data || error?.data;
  if (Array.isArray(data?.message) && data.message[0]?.msg) {
    return data.message[0].msg;
  }
  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }
  return error.message || "An unexpected error occurred.";
};
